import { render, staticRenderFns } from "./template-urutan-satu-sampai-duabelas.vue?vue&type=template&id=f2c7d030&scoped=true&"
import script from "./template-urutan-satu-sampai-duabelas.vue?vue&type=script&lang=js&"
export * from "./template-urutan-satu-sampai-duabelas.vue?vue&type=script&lang=js&"
import style0 from "./template-urutan-satu-sampai-duabelas.vue?vue&type=style&index=0&id=f2c7d030&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c7d030",
  null
  
)

export default component.exports